export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于99漫画
            </h2>
          </div>

          <div className="bg-background-50 rounded-lg p-8 border border-background-200/70">
            <div className="flex items-center justify-center mb-6">
              <span className="text-4xl font-display text-primary-500">99漫画</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              99漫画网创立于对漫画阅读体验的极致追求。我们深知，漫画爱好者需要的不仅是一个内容聚合平台，更是一个能提供流畅、沉浸、便捷阅读体验的精神角落。从韩漫的长条下拉式阅读、日漫的经典翻页模式到国漫的多元风格，99漫画致力于为每一种阅读习惯找到最佳适配方案。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              平台汇聚了数万部优质漫画资源，涵盖韩漫、日漫、国漫三大语种，题材横跨恋爱甜宠、热血战斗、奇幻冒险、悬疑惊悚、搞笑日常、BL/GL、职场商战、科幻未来、古风国漫等全品类。每日准时更新，确保读者第一时间看到最新连载。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed">
              我们坚持免费阅读的理念，让每一个热爱漫画的人无论身处何地、无论预算多少，都能平等地享受漫画带来的快乐。未来，99漫画将继续优化阅读体验、拓展内容资源、打造更活跃的漫友社区，成为你追更路上最可靠的伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}